export default __webpack_public_path__ + "static/media/Group 3032@2x.e19220fd.png";